import { WIDGETS } from "./widgets-library";

const DEFAULT_NAMES = [
    "report-progress",
    "overview",
    "project-breakdown",
    "feecode-breakdown",
    "calendar-schedule",
];

export const DEFAULT_WIDGETS = DEFAULT_NAMES.filter((name) =>
    WIDGETS.find((w) => w.name === name),
).map((name) => ({
    id: `${name}-default`,
    name,
}));

export const MOBILE_WIDGETS_KEY = "v1.1_m-dashboard_widgets";
